import {createSlice, type SliceSelectors} from '@reduxjs/toolkit'

import {getInitialState} from '@web/slices/pagination/slice'

import type {PaginationReducers, MakeSliceOptions} from './interfaces'
import type {PaginationState} from '@web/slices/pagination/slice'

export default (options?: MakeSliceOptions) =>
    createSlice<PaginationState, PaginationReducers, 'pagination', SliceSelectors<PaginationState>>({
        name: 'pagination',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            options?.extraReducers?.(builder)
        },
    })
